import { Component, DestroyRef, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SnowplowService } from './core/services/snowplow.service';
import config from 'devextreme/core/config';
import { licenseKey } from 'src/devextreme.license';
import { OneTrustService } from './common/services/one-trust.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OneTrustConsentGroup } from './common/enums/one-trust-consent-group.enum';

config({
  licenseKey: licenseKey,
});

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private snowplowService: SnowplowService,
    private oneTrustService: OneTrustService,
    private destroyRef: DestroyRef
  ) {
    window.addEventListener('oneTrustLoaded', () => this.oneTrustService.scriptLoadedHandler(), {
      once: true,
    });
  }

  ngOnInit(): void {
    this.oneTrustService
      .hasGivenConsentFor(OneTrustConsentGroup.Analytical)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(hasConsent => {
        if (hasConsent && environment.production) {
          this.snowplowService.startTracking();
        }
      });
  }
}
